import { subject } from "@casl/ability";
import { Group } from "@mantine/core";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import ContextMenuRow from "./ContextMenuRow";

const columnHelper = createColumnHelper<TTipoDeJogada>();

const columns: ColumnDef<TTipoDeJogada>[] = [
  columnHelper.accessor("nome", {
    header: "Nome",
    enableSorting: true,
    enableColumnFilter: true
  }),
  columnHelper.accessor("descricao", {
    header: "Descrição",
    enableSorting: true,
    enableColumnFilter: true
  }),

  columnHelper.display({
    id: "actions",
    cell: (properties) => {
      const tipoDeJogadas = subject("TTipoDeJogada", properties.row.original);

      return (
        <Group justify="center" gap={2}>
          <ContextMenuRow tipoDeJogadas={tipoDeJogadas} />
        </Group>
      );
    }
  })
];

export default columns;
